module.exports = __webpack_public_path__ + "static/media/step5.05c6fda4.png";